import { render, staticRenderFns } from "./AskedQuestion.vue?vue&type=template&id=51201f10&"
import script from "./AskedQuestion.vue?vue&type=script&lang=js&"
export * from "./AskedQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports